module.exports = __webpack_public_path__ + "static/img/app-slide-show3.64dd58f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images/app-slide-show3.png
// module id = xiYx
// module chunks = 44